<ion-item [lines]="itemLines" [disabled]="props.readonly">
  <ng-template #fieldComponent></ng-template>
</ion-item>
@if (showError) {
  <ion-item lines="none">
    <ion-label>
      <ion-text color="danger">
        <p>
          <formly-validation-message [field]="field"></formly-validation-message>
        </p>
      </ion-text>
    </ion-label>
  </ion-item>
}
